__turbopack_context__.v({
  "emailInput": "InputEmail-module-scss-module__fZ5qhG__emailInput",
  "helperText": "InputEmail-module-scss-module__fZ5qhG__helperText",
  "hiddenInput": "InputEmail-module-scss-module__fZ5qhG__hiddenInput",
  "inputIndicator": "InputEmail-module-scss-module__fZ5qhG__inputIndicator",
  "root": "InputEmail-module-scss-module__fZ5qhG__root",
  "suggestedEmail": "InputEmail-module-scss-module__fZ5qhG__suggestedEmail",
});
